import { IBreadcrumbItem, PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPageHeaderProps,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { ActivePermission, FeatureSet } from '../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { ContentsTitle, defaultPanelWidth } from '../../featurestore/models';
import { EditFeatureSet } from '../EditFeatureSet/EditFeatureSet';
import {
  editFeatureSetPanelStylesDefault,
  IEditFeatureSetPanelClassNames,
  IEditFeatureSetPanelStyles,
} from './EditFeatureSetPanel.styles';

const getBreadcrumbItems = (featureName = ''): IBreadcrumbItem[] => {
  return [
    { text: featureName, key: featureName },
    {
      text: ContentsTitle.editFeatureSet,
      key: ContentsTitle.editFeatureSet,
      isCurrentItem: true,
    },
  ];
};

interface IEditFeatureSetPanelProps {
  id?: string;
  name?: string;
  permission?: ActivePermission;
  show: boolean;
  onDismiss: (
    ev?: KeyboardEvent | React.SyntheticEvent<HTMLElement, Event> | undefined,
    updatedFeatureSet?: FeatureSet,
    deleted?: boolean
  ) => void;
}

export const EditFeatureSetPanel = ({ id = '', name = '', permission, show, onDismiss }: IEditFeatureSetPanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: defaultPanelWidth,
    isOpen,
    onDismiss,
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  const pageHeaderProps: IPageHeaderProps = {
    pageTitle: ContentsTitle.editFeatureSet,
    styles: pageHeaderStylesSecondary,
    breadcrumbProps: {
      items: getBreadcrumbItems(name),
    },
    actions: <IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<IEditFeatureSetPanelStyles, IEditFeatureSetPanelClassNames>(
    'EditFeatureSetPanel',
    editFeatureSetPanelStylesDefault
  );
  return (
    <Panel {...panelProps} data-test="EditFeatureSetPanel">
      <div className={classNames.root}>
        <PageHeader {...pageHeaderProps} />
        <EditFeatureSet
          id={id}
          permission={permission}
          onUpdate={(deleted, featureSet) => onDismiss(undefined, featureSet, deleted)}
          onCancel={onDismiss}
        />
      </div>
    </Panel>
  );
};
